<template>
  <div class="container mx-auto">
    <div class="mx-4 mt-6 md:mt-8">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Register",
  computed: {
    ...mapGetters(["getRegistrationUser","getIdentities"]),
    registrationUser() {
      return this.getRegistrationUser;
    },
    identities() {
      return this.getIdentities;
    }
  }
};
</script>

<style lang="scss" scoped></style>
